import { TaskType } from "@myapp/contract";
import { ISelectOption } from "../../../shared/types/ISelectOption";

const TASK_TYPE_LABELS: Record<TaskType, string> = {
  ERRANDS: "Besorgung",
  GENERAL_TASK: "Allgemeine Aufgabe",
};

export const getTaskTypeLabel = (type: TaskType): string => TASK_TYPE_LABELS[type];

export const taskTypeOptions: ISelectOption[] = (
  Object.keys(TASK_TYPE_LABELS) as TaskType[]
).map((type) => ({ value: type, label: TASK_TYPE_LABELS[type] }));
